var map = {
	"./Eight.png": 32726,
	"./Five.png": 79791,
	"./Four.png": 40475,
	"./Nine.png": 63759,
	"./One.png": 44355,
	"./Seven.png": 10240,
	"./Six.png": 45079,
	"./Three.png": 34263,
	"./Two.png": 28225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69337;